export const SHOW_TOAST_MESSAGE = 'SHOW_TOAST_MESSAGE';

export const showToastMessage = (message, timeOut) => async dispatch => {
  dispatch({
    type: SHOW_TOAST_MESSAGE,
    message,
    timeOut,
  });
};
